import React, { useState } from "react";

import { Box } from "@mui/material";
import { isEmpty } from "lodash";
import { withStyles } from "tss-react/mui";

import { ClientExerciseCommentFragment } from "@/gql/graphql";

import ExerciseComment from "./ExerciseComment";
import ExerciseCommentEmptyView from "./ExerciseCommentEmptyView";
import ExerciseCommentField from "./ExerciseCommentField";
import { useActions } from "../ClientExercisesPage";

interface Props {
  comments: ClientExerciseCommentFragment[];
  coachId?: string;
}

const Root = withStyles(Box, (theme) => ({
  root: {
    marginTop: "8px",
    minHeight: "45vh",
    padding: theme.spacing(3, 0, 0),
  },
}));

const CommentsContainer = withStyles(Box, {
  root: {
    minHeight: "45vh",
  },
});

const CommentFieldContainer = withStyles(Box, {
  root: {
    flex: 0,
  },
});

const ExerciseComments: React.FC<Props> = ({ coachId, comments }) => {
  const [newComment, setNewComment] = useState<string>("");

  const dispatch = useActions();

  const handleSubmit = async (value: string) => {
    return dispatch({
      type: "COMMENT_ON_EXERCISE",
      payload: { comment: value },
    })
      .then(() => {
        // empty out the comment text field
        setNewComment("");
      })
      .catch(() => {
        // keep comment in text field so that user can try again quickly.
        setNewComment(value);
      });
  };

  const renderContent = () => {
    if (isEmpty(comments)) return <ExerciseCommentEmptyView />;

    return (
      <CommentsContainer>
        {comments.map((comment, index) => {
          const isLastItem = index === comments.length - 1;

          return (
            <Box key={comment.id}>
              <ExerciseComment coachId={coachId} commentId={comment.id} />
              {!isLastItem && <Box height="1px" bgcolor="#EDF0F5" />}
            </Box>
          );
        })}
      </CommentsContainer>
    );
  };

  return (
    <Root>
      {renderContent()}
      <CommentFieldContainer>
        <ExerciseCommentField
          value={newComment}
          onChangeText={setNewComment}
          onSubmit={handleSubmit}
        />
      </CommentFieldContainer>
    </Root>
  );
};

export default ExerciseComments;
